import React, { createContext, useContext, useState, ReactNode } from 'react';

interface PageHeaderInfo {
  title: string;
  description: string;
  hideHeader?: boolean;
}

interface PageHeaderContextType {
  pageInfo: PageHeaderInfo | null;
  setPageInfo: (info: PageHeaderInfo | null) => void;
}

const PageHeaderContext = createContext<PageHeaderContextType | undefined>(undefined);

export const PageHeaderProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  const [pageInfo, setPageInfo] = useState<PageHeaderInfo | null>(null);

  return (
    <PageHeaderContext.Provider value={{ pageInfo, setPageInfo }}>
      {children}
    </PageHeaderContext.Provider>
  );
};

export const usePageHeader = () => {
  const context = useContext(PageHeaderContext);
  if (!context) {
    throw new Error('usePageHeader must be used within a PageHeaderProvider');
  }
  return context;
};